"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseTelephoneInput = exports.normalizeTelephone = exports.isValidTelephone = void 0;
var normalize_telephone_1 = require("../utils/normalize-telephone");
Object.defineProperty(exports, "isValidTelephone", {
  enumerable: true,
  get: function () {
    return normalize_telephone_1.isValidTelephone;
  }
});
Object.defineProperty(exports, "normalizeTelephone", {
  enumerable: true,
  get: function () {
    return normalize_telephone_1.normalizeTelephone;
  }
});
Object.defineProperty(exports, "parseTelephoneInput", {
  enumerable: true,
  get: function () {
    return normalize_telephone_1.parseTelephoneInput;
  }
});
//# sourceMappingURL=telephone.validator.js.map